import {
    EditedBannerImage,
    EditedBannerTypeImage,
    EditedBannerTypeMcBanner,
    EditedBannerTypeText
} from '../typings/bannersEditState';
import { PageStatus } from '../typings/common';
import { AdvType } from '../typings/domain';
import {
    GdUpdateSmartCentersInput,
    GdUpdateSmartCentersItemInput
} from '../typings/graphql-grid';
import {
    ImageSmartCenterEditorData,
    SMART_CENTER_RATIOS,
    SMART_CENTER_RATIOS_ORDER,
    SmartCenterInfo
} from '../typings/imageSmartCenterEditor';

export function mapImageSmartCenterData(
    banner:
        | EditedBannerTypeText
        | EditedBannerTypeImage
        | EditedBannerTypeMcBanner,
    bannerImage: EditedBannerImage
): ImageSmartCenterEditorData | undefined {
    const image = bannerImage.data;
    if (
        !image ||
        !image.formats ||
        !image.formats.length ||
        banner.bannerType === AdvType.MCBANNER
    ) {
        return undefined;
    }

    // находим формат с наибольшей шириной
    // в качестве первого вариант принимаем первое значение format[0]
    // и сравниваем его ширину с остальными (начиная со второго slice(1))
    const mainFormat = image.formats
        .slice(1)
        .reduce((maxWidthFormat, format) => {
            if (format.width > (maxWidthFormat ? maxWidthFormat.width : 0)) {
                return format;
            }
            return maxWidthFormat;
        }, image.formats[0]);

    const smartCenters = SMART_CENTER_RATIOS_ORDER.reduce(
        (
            centers: Record<string, SmartCenterInfo>,
            ratio: SMART_CENTER_RATIOS
        ) => {
            const center = mainFormat.smartCenters.find(
                ({ ratio: currentRatio }) => currentRatio === ratio
            );
            if (center) {
                centers[ratio] = {
                    size: {
                        h: center.h,
                        w: center.w
                    },
                    pos: {
                        x: center.x,
                        y: center.y
                    }
                };
            }
            return centers;
        },
        {}
    );

    const [formatId, imageHash] = mainFormat.url.split('/').reverse();

    return {
        bannerId: banner.id,
        imageUrl: mainFormat.url,
        centers: smartCenters,
        imageSize: {
            width: mainFormat.width,
            height: mainFormat.height
        },
        sortOrder: SMART_CENTER_RATIOS_ORDER,
        selectedId: SMART_CENTER_RATIOS.ONE_BY_ONE,
        formatId,
        imageHash,
        status: PageStatus.LOADED
    };
}

export function mapImageSmartCentersDataToApiInput(
    data: ImageSmartCenterEditorData
): GdUpdateSmartCentersInput {
    return {
        imageHash: data.imageHash,
        smartCenters: Object.keys(data.centers).reduce(
            (
                acc: Array<GdUpdateSmartCentersItemInput>,
                format: SMART_CENTER_RATIOS
            ) => {
                const center = data.centers[format];
                if (!center) {
                    return acc;
                }
                return acc.concat({
                    size: data.formatId,
                    smartCenter: {
                        ratio: format,
                        x: center.pos.x,
                        y: center.pos.y
                    }
                });
            },
            []
        )
    };
}
